import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Spinner from 'react-spinkit';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'; // ES6
import _ from 'lodash';

import InstructorHomeView from '../components/InstructorHomeView';
import StudentHomeView from '../components/StudentHomeView';
import HiddenHomeView from '../components/HiddenHomeView';
import HighestDropboxRoleSelector from '../selectors/HighestDropboxRoleSelector';
import * as ROLES from '../constants/roles';
import {
    ASSIGNMENTS__REQUESTED,
    ASSIGNMENT__DELETE__REQUESTED,
    ASSIGNMENT__CLEAR__REQUESTED,
    DROPBOXES__REQUESTED,
    LOGS__CLEAR__REQUESTED,
    ROLES__SELF__REQUESTED,
    SEMESTERS__REQUESTED,
    SUBMISSION__CLEAR__REQUESTED
} from "../constants/actionTypes";

class HomePage extends Component {

    constructor(props) {
        super(props);

        this.deleteAssignmentHandler = this.deleteAssignmentHandler.bind(this);
    }

    componentDidMount() {
        const { assignments, dispatch, dropboxes, roles_self, semesters } = this.props;

        if (_.size(roles_self) < 1) {
            dispatch({
                type: ROLES__SELF__REQUESTED
            });
        }

        if (_.size(semesters) < 1) {
            dispatch({
               type: SEMESTERS__REQUESTED,
            });
        }

        if (_.size(dropboxes) < 1) {
            dispatch({
                type: DROPBOXES__REQUESTED,
            });
        }

        if (_.size(assignments) < 1) {
            dispatch({
                type: ASSIGNMENTS__REQUESTED,
            });
        }

        // clear unused state on homepage
        dispatch({
            type: ASSIGNMENT__CLEAR__REQUESTED
        });

        dispatch({
            type: SUBMISSION__CLEAR__REQUESTED
        });

        dispatch({
            type: LOGS__CLEAR__REQUESTED
        });
    }

    renderDropbox(dropbox) {
        return (
            <div key={dropbox.name}>
                {
                    this.props.dropboxes[dropbox.id]
                    ? this.renderView(this.props.dropboxes[dropbox.id])
                    : null
                }
            </div>
        );
    }

    renderView(dropbox) {
        if (!this.props.routing) {
            return null;
        }

        const { expand } = this.props.routing.locationBeforeTransitions.query;

        const { assignments, dispatch, roles_self, request, semesters } = this.props,
            highestRole = HighestDropboxRoleSelector(
                {
                    roles: _.filter(
                        roles_self,
                        role => {
                            return role.dropbox.id === dropbox.id;
                        }
                    )
                }
            ),
            dropboxAssignments =  _.mapKeys(
                _.filter(assignments, assignment => {
                    return assignment.dropbox.id === dropbox.id;
                }),
                'id'
            )
        ;

        switch (true) {
            case highestRole === ROLES.INSTRUCTOR:
                return (
                    <InstructorHomeView
                        assignments={dropboxAssignments}
                        dispatch={dispatch}
                        dropbox = {dropbox}
                        deleteAssignmentHandler = {this.deleteAssignmentHandler}
                        expanded={expand}
                        request={request}
                        semesters={semesters}
                    />
                );
            case highestRole === ROLES.INSTRUCTOR_VIEW_ONLY:
                return (
                    <StudentHomeView
                        assignments={dropboxAssignments}
                        dropbox = {dropbox}
                        expanded={expand}
                        semesters={semesters}
                    />
                );
            case dropbox.show_index < 1:
                return (
                    <HiddenHomeView
                        assignments={dropboxAssignments}
                        dropbox = {dropbox}
                        expanded={expand}
                        semesters={semesters}
                    />
                );
            case highestRole === ROLES.STUDENT:
                return (
                    <StudentHomeView
                        assignments={dropboxAssignments}
                        dropbox = {dropbox}
                        expanded={expand}
                        semesters={semesters}
                    />
                );
        }
    }

    deleteAssignmentHandler(data) {
       const { assignmentId, dropboxId } = data;

        this.props.dispatch({
            type: ASSIGNMENT__DELETE__REQUESTED,
            payload: { assignmentId, dropboxId },
        });
    }

    render() {
        const isLoading = this.props.request.sendingRequest;

        let spinner = null;

        if(isLoading){
            spinner = <Spinner spinnerName="wandering-cubes" className="spinner" noFadeIn/>;
        }

        let sortedSemesters = _.orderBy(
            this.props.semesters,
            [
                semester => {
                    return semester.year;
                },
                semester => {
                    return semester.season;
                }
            ],
            ['desc', 'asc']
        );

        return (
            <div className="col-md-12 home-page">
                <h3>My Courses</h3>
                {spinner}
                <div id="accordion" className="table-responsive" role="tablist" aria-multiselectable="true">
                    <ReactCSSTransitionGroup
                        transitionName="content"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={300}
                    >
                        <ul className="list-group">
                            {
                                _.map(
                                    sortedSemesters,
                                    semester => {
                                        let sortedDropboxes = _.orderBy(
                                            this.props.dropboxes,
                                            [
                                                dropbox => {
                                                    return dropbox.name;
                                                }
                                            ],
                                            ['asc']
                                        );
                                        return _.map(
                                            sortedDropboxes,
                                            dropbox => {
                                                if (dropbox.semester.id === semester.id) {
                                                    return this.renderDropbox(dropbox);
                                                }
                                            }
                                        );
                                    }
                                )
                            }
                        </ul>
                    </ReactCSSTransitionGroup>
                </div>
            </div>
        );
    }
}

HomePage.propTypes = {
    assignments: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    dropboxes: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    roles_self: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    routing: PropTypes.object.isRequired,
    semesters: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const { assignments, dispatch, dropboxes, roles_self, routing, request, semesters } = state;

    return { assignments, dispatch, dropboxes, roles_self, routing, request, semesters };
}

export default connect(mapStateToProps)(withRouter(HomePage));



/** WEBPACK FOOTER **
 ** ./src/containers/HomePage.js
 **/